
(function ($, document, ns) {
    ns.ShowModal = function (renderModal) {
        var $modal = $('#modal-content');
        if (!$modal.length) {
            $modal = $('<div id="modal-content" class="reveal-modal" data-reveal aria-hidden="true" role="dialog" />').appendTo('body');
        }
        $modal.html(renderModal());
        $modal.foundation('reveal', 'open');
    };
})(jQuery, document, Crafted.Utilities);